import { notification } from "antd"

export const ToastMessage = ({
  type,
  message,
  description = "",
  clickedFunction,
  className,
}) => {
  notification.open({
    message: message,
    description: description,
    className: className,
    onClick: () => {
      if (clickedFunction) clickedFunction()()
    },
    style: clickedFunction ? { cursor: "pointer" } : null, // hand curson for clickable notification
  })
}

export const ToastMessageDestroy = () => {
  notification.destroy()
}

export const NOTIFICATION_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
  INFO: "info",
  WARNING: "warn",
}
